export default __webpack_public_path__ + "static/media/Without Medication.bcca6800.png";